import { Plugin } from '@nuxt/types'

export default (({ store }) => {
  if (process.client) {
    store?.dispatch('growthbook/init')
  }
}) as Plugin
